export default {
    JUST_TEXT: 'JUST_TEXT',
    JUST_ATTACHMENT: 'JUST_ATTACHMENT',
    TEXT_AND_ATTACHMENT: 'TEXT_AND_ATTACHMENT',
    SMALL_TEXT: 'SMALL_TEXT',
};

export const translatedActivityContentTypes = {
    JUST_TEXT: 'Apenas campo de texto',
    JUST_ATTACHMENT: 'Apenas anexos',
    TEXT_AND_ATTACHMENT: 'Campo de texto e anexos',
    SMALL_TEXT: 'Campo de texto curto',
};



// WEBPACK FOOTER //
// ./src/utils/activity-content-types.js